import { Avatar, Box  } from "@chakra-ui/react";
// import * as Html from 'view-layer/styled/html';

interface PropsType {
  firstName: string,
  lastName: string,
  reservationId: string,
  [key: string]: unknown;
}

export const CustomerData = ({ firstName, lastName, reservationId, ...props }: PropsType) => (
  <Box
    data-testid="customer-data"
    fontSize={'14px'}
    lineHeight={'20px'}
    display={'flex'}
    flexDirection="row"
    height={'40px'}
    width={'250px'}
    {...props}
  >
    <Box flex={'0 0 50px'} height={'40px'}>
      <Avatar name={`${firstName} ${lastName}`} src="" bg={'#F1F3F4'} />
    </Box>
    <Box flex={'0 0 250px'} flexDir={'column'}>
      <Box pl={2} height={'20px'} fontWeight={500} textTransform={'capitalize'}>{firstName} {lastName}</Box>
      <Box pl={2} height={'20px'}>{reservationId}</Box>
    </Box>
  </Box>
);
